import { render } from "./MentionsLegales.vue?vue&type=template&id=50be3793&scoped=true"
import script from "./MentionsLegales.vue?vue&type=script&lang=js"
export * from "./MentionsLegales.vue?vue&type=script&lang=js"

import "./MentionsLegales.vue?vue&type=style&index=0&id=50be3793&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50be3793"]])

export default __exports__